import VueAwesomeSwiper from 'vue-awesome-swiper';
import KishInput from '../components/Shared/InputKish/index.vue'

const GlobalComponents = {
  // use packages
  install(Vue) {
    Vue.use(VueAwesomeSwiper);
    Vue.component('kish-input', KishInput);

  },
};

export default GlobalComponents;
